<template>
  <div class="page">
    <h2>Branch Expenses</h2>
    <div class="card" style="padding:16px;margin-top:12px;max-width:520px;">
      <div class="row">
        <label class="helper">Month</label>
        <input type="month" class="input" v-model="monthKey" @change="load">
      </div>

      <div class="row" style="margin-top:12px;">
        <label class="helper">Amount (₹)</label>
        <input class="input" type="number" v-model.number="amount" min="0">
      </div>

      <div class="row" style="margin-top:16px;">
        <button class="btn primary" :disabled="busy" @click="save">{{ busy ? 'Saving…' : 'Save' }}</button>
      </div>
      <div v-if="msg" class="helper" style="margin-top:8px;color:#2b7;">{{ msg }}</div>
      <div v-if="err" class="helper" style="margin-top:8px;color:#d33;">{{ err }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name:'BranchExpenses',
  data(){
    return {
      monthKey: new Date().toISOString().slice(0,7),
      amount: 0,
      busy:false, msg:'', err:''
    }
  },
  async mounted(){ await this.load() },
  methods:{
    async load(){
      this.msg=''; this.err=''
      try{
        const u = this.$store.getters['auth/currentUser']
        this.amount = await this.$store.dispatch('expenses/get', {
          branchId: u.branchId, monthKey: this.monthKey
        })
      }catch(e){
        this.err = 'Failed to load'
      }
    },
    async save(){
      this.msg=''; this.err=''; this.busy=true
      try{
        const u = this.$store.getters['auth/currentUser']
        await this.$store.dispatch('expenses/setExpense', {
          branchId: u.branchId, monthKey: this.monthKey, amount: this.amount
        })
        this.msg = 'Saved ✓'
      }catch(e){
        this.err = 'Failed to save'
      }finally{
        this.busy=false
      }
    }
  }
}
</script>
